import { WorkScheduleActionTypes } from "./constants";

const INIT_STATE = {
  workSchedule: {
    list: [],
    shiftNameList: [],
    byDayOfWeekList: [],
    byDay: [],
    option: [],
    byShift: [],
  },
  loading: true,
  error: null,
};

const WorkSchedule = (state = INIT_STATE, action) => {
  switch(action.type) {
    case WorkScheduleActionTypes.API_RESPONSE_SUCCESS:
      switch(action.payload.actionType) {
        case WorkScheduleActionTypes.GET_WORK_SCHEDULE_LIST: {
          return {
            ...state,
            workSchedule: {
              ...state.workSchedule,
              list: action.payload.data,
            },
            loading: false,
            error: null
          }
        }
        
        case WorkScheduleActionTypes.GET_WORK_SCHEDULE_SHIFT_NAME_LIST: {
          return true
        }
        default:
          return { ...state }
      }
    case WorkScheduleActionTypes.API_RESPONSE_ERROR:
      switch(action.payload.actionType) {
        case WorkScheduleActionTypes.GET_WORK_SCHEDULE_LIST:
          return {
            ...state,
            workSchedule: [ state.list, action.payload.error ],
            loading: false
          }
        default:
          return {
            ...state,
          }
      }
    case WorkScheduleActionTypes.RESET_WORK_SCHEDULE_LIST:
      return true;
    case WorkScheduleActionTypes.RESET_WORK_SCHEDULE_SHIFT_NAME_LIST:
      return true;
    
      default:
        return { ...state }
  }
}

export default WorkSchedule;